module.exports = __webpack_public_path__ + "img/company_logo.e9681cf6.png";